import { Flex, Menu, MenuList } from '@chakra-ui/react'
import { FaCheckCircle, FaChevronDown, FaCopy, FaEye, FaPencilAlt, FaRegTimesCircle, FaTrashAlt } from 'react-icons/fa'
import { AccordionContainer } from '../../../../../components/AccordionContainer'
import { MenuButtonCmp } from '../../../../../components/MenuButtonCmp'
import { StyledMenuItem } from '../../../../../components/NavBar/Components/StyledMenuItem'
import { TableDiv } from '../Tabela/styles'

export interface iQuestaoFormFeedback {
  id: string
  enunciado: string
  tipo: number
  obrigatoria: boolean
}

export interface iFormFeedback {
  id: string
  nome: string
  questoes: iQuestaoFormFeedback[]
}

interface iProps {
  formulario: iFormFeedback
  onEditar: (formId: string) => void
  onDuplicar: (formId: string) => void
  onPrevisualizar: (formId: string) => void
  onDelete: (formId: string) => void
}

const TIPO_MULTIPLA_ESCOLHA = 0
const TIPO_DISCURSIVA = 1
const TIPO_CAIXA_SELECAO = 5

function NomeTipo(tipo: number): string {
  if (tipo === TIPO_MULTIPLA_ESCOLHA) return 'Múltipla escolha'
  if (tipo === TIPO_DISCURSIVA) return 'Discursiva'
  if (tipo === TIPO_CAIXA_SELECAO) return 'Caixa de seleção'
  return '-'
}

export const FeedbackFormCard: React.FC<iProps> = ({ formulario, onEditar, onDuplicar, onPrevisualizar, onDelete }) => {
  const questoes = formulario.questoes ?? []

  function ReturnIcon(e: boolean): any {
    if (e) {
      return <FaCheckCircle color='var(--v2)' style={{ marginRight: '.3rem' }} />
    } else {
      return <FaRegTimesCircle color='var(--terc3)' style={{ marginRight: '.3rem' }} />
    }
  }

  return (
    <Flex w={'full'} bg={'white'} pt={'.75rem'} px={'1rem'} flexWrap={'wrap'} borderRadius={'.25rem'} boxShadow={'var(--SombraBackground)'}>
      <Flex w={'full'}>
        <Flex flexDir={'column'} gap={'.3rem'} flex={'1'}>
          <h4>
            Nome do formulário:
            <span style={{ fontWeight: 700 }}> {formulario.nome}</span>
          </h4>
          <Flex fontSize={'.75rem'} fontWeight={'500'} color={'var(--c7)'} mb={questoes.length > 0 ? '' : '1rem'}>
            {questoes.length === 1 ? '1 questão' : `${questoes.length} questões`}
          </Flex>
        </Flex>
        <Flex gap={'.5rem'}>
          <Flex gap={'.5rem'} alignSelf={'start'} fontSize={'.813rem'} mr={'.5rem'}>
            <Flex alignItems={'center'}>{ReturnIcon(questoes.some(e => e.tipo === TIPO_MULTIPLA_ESCOLHA))} Múltipla escolha</Flex>
            <Flex alignItems={'center'}>{ReturnIcon(questoes.some(e => e.tipo === TIPO_DISCURSIVA))} Discursiva</Flex>
            <Flex alignItems={'center'}>{ReturnIcon(questoes.some(e => e.tipo === TIPO_CAIXA_SELECAO))} Caixa de seleção</Flex>
            <Flex alignItems={'center'}>{ReturnIcon(questoes.some(e => e.obrigatoria))} Questões obrigatórias</Flex>
          </Flex>
          <Menu>
            <MenuButtonCmp
              Icon={<FaChevronDown size={8} style={{ marginLeft: '-4px' }}/>}
              VarColor='Rosa'
            >Opções
            </MenuButtonCmp>
            <MenuList bg={'white'} borderRadius={'.5rem'} boxShadow={'0px 2px 8px rgba(0, 0, 0, 0.25)'}>
              <StyledMenuItem onClick={() => onEditar(formulario.id)}>
                <FaPencilAlt style={{ marginRight: '.375rem' }} size={'14'}/>
                Editar
              </StyledMenuItem>
              <StyledMenuItem onClick={() => onDuplicar(formulario.id)}>
                <FaCopy style={{ marginRight: '.375rem' }} size={'14'}/>
                Duplicar
              </StyledMenuItem>
              <StyledMenuItem onClick={() => onPrevisualizar(formulario.id)}>
                <FaEye style={{ marginRight: '.375rem' }} size={'14'}/>
                Pré-visualizar
              </StyledMenuItem>
              <StyledMenuItem onClick={() => onDelete(formulario.id)}>
                <FaTrashAlt style={{ marginRight: '.375rem' }} size={'14'}/>
                Excluir
              </StyledMenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Flex>
      {questoes.length > 0 &&
        <AccordionContainer title='Lista de questões' hideHr>
          <Flex width={'100%'} pb={'.75rem'}>
            <TableDiv>
              <table>
                <thead>
                  <tr>
                    <th>Questão</th>
                    <th>Tipo</th>
                    <th>Obrigatória</th>
                  </tr>
                </thead>
                <tbody>
                  {questoes.map(e => (
                    <tr key={e.id}>
                      <td style={{ textAlign: 'left' }}>{e.enunciado === '' ? 'Questão sem enunciado' : e.enunciado}</td>
                      <td>{NomeTipo(e.tipo)}</td>
                      <td>{e.obrigatoria ? 'Sim' : 'Não'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TableDiv>
          </Flex>
        </AccordionContainer>
      }
    </Flex>
  )
}
